import { onChangeCreator, updateWithYearlyDayOfMonth,
  updateWithYearlyDayOfWeek, updateWithYearlyOnDayMonth,
  updateWithYearlyOccurence, updateWithYearlyOption, updateWithYearsInterval, updateWithYearlyOnWeekdayMonth } 
from './schedule-helpers';
import * as React from 'react';
import { Numberbox, SelectSingle } from 'ui';
import { SelectSingleRadioButton } from 'ui/select-single-short-list/select-single-radio-button/select-single-radio-button';
import { RecurringYearlyOptions, ScheduleFieldKeys } from 'app/area/company-report/constants';
import styles from './report-screen.scss';

// eslint:disable-next-line: max-func-body-length
export const YearlySchedule = ({
  setScheduleDefinition,
  scheduleDefinition,
  scheduleMonthOptions,
  scheduleWeekdayOptions,
  occurenceOptions,
  translations,
  locale,
  getValidationErrors
}) => {

  const onChangeYearsInterval = onChangeCreator(updateWithYearsInterval, setScheduleDefinition);
  const onChangeYearlyOption = onChangeCreator(updateWithYearlyOption, setScheduleDefinition);
  const onChangeYearlyOnDayMonth = onChangeCreator(updateWithYearlyOnDayMonth, setScheduleDefinition);
  const onChangeYearlyDayOfMonth = onChangeCreator(updateWithYearlyDayOfMonth, setScheduleDefinition);
  const onChangeYearlyDayOfWeek = onChangeCreator(updateWithYearlyDayOfWeek, setScheduleDefinition);
  const onChangeYearlyOccurence = onChangeCreator(updateWithYearlyOccurence, setScheduleDefinition);
  const onChangeYearlyOnWeekdayMonth = onChangeCreator(updateWithYearlyOnWeekdayMonth, setScheduleDefinition);

  const {
    option, 
    yearsInterval,
    month1: onDayMonth,
    month2: onWeekdayMonth,
    dayOfMonth,
    dayOfWeek,
    occurrence
  } = scheduleDefinition?.recurYearly;
  
  const isSelected = (value: number): boolean => option?.value === value;

  return <div>
    <div className={`${styles.scheduleRow}`}>
      <div className={styles.textWrapper}>
        <span className={styles.texts}>{translations.recur_every}</span>
      </div>
      <div>
        <Numberbox
          componentId={ScheduleFieldKeys.recurYearlyYearsInterval}
          value={yearsInterval}
          onChange={onChangeYearsInterval}
          className={styles.scheduleNumberbox}
          locale={locale}
          validation={getValidationErrors(ScheduleFieldKeys.recurYearlyYearsInterval)}
          maxValue={999999999}
        />
      </div>
      <div className={styles.textWrapper}>
        <span className={styles.texts}>{translations.years}</span>
      </div>
    </div>
    <div className={`${styles.scheduleRow}`}>
      <div className={styles.textWrapper}>
        <SelectSingleRadioButton
            componentId={`${ScheduleFieldKeys.recurYearlyOption}-${RecurringYearlyOptions.onDayOfMonth}`}
            onChange={onChangeYearlyOption}
            isSelected={isSelected(RecurringYearlyOptions.onDayOfMonth)}
            option={{ value: RecurringYearlyOptions.onDayOfMonth, description: translations.on }}
            validation={getValidationErrors(ScheduleFieldKeys.recurYearlyOption)}
          />
      </div>
      <div>
        <SelectSingle
          componentId={ScheduleFieldKeys.recurYearlyMonth1}
          onChange={onChangeYearlyOnDayMonth}
          className={styles.scheduleSelectSingle}
          valueItem={onDayMonth}
          options={scheduleMonthOptions}
          readOnly={!isSelected(RecurringYearlyOptions.onDayOfMonth)}
          validation={getValidationErrors(ScheduleFieldKeys.recurYearlyMonth1)}
        />
      </div>
      <div>
        <Numberbox
          componentId={ScheduleFieldKeys.recurYearlyDayOfMonth}
          value={dayOfMonth}
          onChange={onChangeYearlyDayOfMonth}
          className={styles.scheduleNumberbox}
          readOnly={!isSelected(RecurringYearlyOptions.onDayOfMonth)}
          locale={locale}
          validation={getValidationErrors(ScheduleFieldKeys.recurYearlyDayOfMonth)}
          maxValue={999999999}
        />
      </div>
    </div>
    <div className={`${styles.scheduleRow}`}>
      <div className={styles.textWrapper}>
        <SelectSingleRadioButton
          componentId={`${ScheduleFieldKeys.recurYearlyOption}-${RecurringYearlyOptions.onWeekday}`}
          onChange={onChangeYearlyOption}
          isSelected={isSelected(RecurringYearlyOptions.onWeekday)}
          option={{ value: RecurringYearlyOptions.onWeekday, description: translations.on_the }}
          validation={getValidationErrors(ScheduleFieldKeys.recurYearlyOption)}
        />
      </div>
      <div>
        <SelectSingle
          componentId={ScheduleFieldKeys.recurYearlyOccurence}
          onChange={onChangeYearlyOccurence}
          className={styles.scheduleSelectSingle}
          valueItem={occurrence}
          options={occurenceOptions}
          readOnly={!isSelected(RecurringYearlyOptions.onWeekday)}
          validation={getValidationErrors(ScheduleFieldKeys.recurYearlyOccurence)}
        />
      </div>
      <div>
        <SelectSingle
          componentId={ScheduleFieldKeys.recurYearlyDayOfWeek}
          onChange={onChangeYearlyDayOfWeek}
          className={styles.scheduleSelectSingle}
          valueItem={dayOfWeek}
          options={scheduleWeekdayOptions}
          readOnly={!isSelected(RecurringYearlyOptions.onWeekday)}
          validation={getValidationErrors(ScheduleFieldKeys.recurYearlyDayOfWeek)}
        />
      </div>
      <div className={styles.textWrapper}>
        <span className={styles.texts}>{translations.of}</span>
      </div>
      <div>
        <SelectSingle
          componentId={ScheduleFieldKeys.recurYearlyMonth2}
          onChange={onChangeYearlyOnWeekdayMonth}
          className={styles.scheduleSelectSingle}
          valueItem={onWeekdayMonth}
          options={scheduleMonthOptions}
          readOnly={!isSelected(RecurringYearlyOptions.onWeekday)}
          validation={getValidationErrors(ScheduleFieldKeys.recurYearlyMonth2)}
        />
      </div>
    </div>
  </div>;
};
